/**
 * @generated SignedSource<<8f16083d41928fb0f2cddfb11b7fc035>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsLanding_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpRespSimilarItemsLanding_user";
};
export type PdpRespSimilarItemsLanding_user$key = {
  readonly " $data"?: PdpRespSimilarItemsLanding_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsLanding_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemsLanding_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "efd46591c1c72ad3241e91524989dba3";

export default node;
